var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 28.5C13.5 29.625 13.185 30.69 12.63 31.59C11.595 33.33 9.69 34.5 7.5 34.5C5.31 34.5 3.405 33.33 2.37 31.59C1.815 30.69 1.5 29.625 1.5 28.5C1.5 25.185 4.185 22.5 7.5 22.5C10.815 22.5 13.5 25.185 13.5 28.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16406 28.4993L6.64907 29.9843L9.84407 27.0293",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6291 10.575C26.2691 10.515 25.8941 10.5 25.5041 10.5H10.5041C10.0841 10.5 9.67906 10.53 9.28906 10.59C9.49906 10.17 9.79907 9.78001 10.1591 9.42001L15.0341 4.53C17.0891 2.49 20.4191 2.49 22.4741 4.53L25.0991 7.18494C26.0591 8.12994 26.5691 9.32995 26.6291 10.575Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33 18V25.5C33 30 30 33 25.5 33H11.445C11.91 32.61 12.315 32.13 12.63 31.59C13.185 30.69 13.5 29.625 13.5 28.5C13.5 25.185 10.815 22.5 7.5 22.5C5.7 22.5 4.095 23.295 3 24.54V18C3 13.92 5.46 11.07 9.285 10.59C9.675 10.53 10.08 10.5 10.5 10.5H25.5C25.89 10.5 26.265 10.515 26.625 10.575C30.495 11.025 33 13.89 33 18Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33 18.75H28.5C26.85 18.75 25.5 20.1 25.5 21.75C25.5 23.4 26.85 24.75 28.5 24.75H33",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvice);
export default __webpack_public_path__ + "static/media/advice.1337e89223aab761cafcb66efe095e10.svg";
export { ForwardRef as ReactComponent };